import parser from 'posthtml-parser'
import render from 'posthtml-render'
import { MEDIA_ID_DATA_ATTRIBUTE } from '@fmpedia/enums'
import { pipe } from 'ramda'
import {
  getAltTextForMediaCenterImage,
  getFirstRegexGroups
} from '@/plugins/helper'
import { HTML_TAG } from '@/utils/helpers/processHtml/enums'
import { ImageHtml } from '@/utils/helpers/processHtml/imageHtml'

const replaceImageProps = (images, getDefaultAlt) => parsedHtml => {
  if (!Array.isArray(parsedHtml) || !parsedHtml.length) return []

  return parsedHtml.map(elem => {
    if (elem == null || typeof elem !== 'object') return elem

    const { tag, attrs, content } = elem

    if (tag === HTML_TAG.FIGURE) {
      const elemHtml = render([elem])
      const newImage = new ImageHtml(elemHtml)

      const targetImageData = images.find(
        img => img.mediaId === newImage.dataMediaId
      )

      if (!targetImageData) return elem

      const defaultAlt =
        (getDefaultAlt &&
          typeof getDefaultAlt === 'function' &&
          getDefaultAlt(targetImageData)) ||
        ''

      const { caption } = targetImageData

      newImage.altText =
        getAltTextForMediaCenterImage(targetImageData) || defaultAlt
      newImage.caption = caption

      return newImage.getFinalImageHtml()
    }

    return {
      tag,
      attrs,
      content: replaceImageProps(images, getDefaultAlt)(content)
    }
  })
}

const mediaIdsRegex = new RegExp(
  `<figure[^>]+${MEDIA_ID_DATA_ATTRIBUTE}=["'](.*?)["']`,
  'gmi'
)

export const getParsedImagesIdsFromHtml = html => {
  if (!html) return []

  const matchResult = getFirstRegexGroups(mediaIdsRegex, html)

  return [...new Set(matchResult)].filter(id => id)
}

export const getParsedHtmlWithReplacedImageProps = (
  html,
  images,
  getDefaultAlt = null
) => {
  if (!Array.isArray(images) || !images.length) return html

  return pipe(parser, replaceImageProps(images, getDefaultAlt), render)(html)
}
